export default __webpack_public_path__ + "static/media/medihelp-img.6ca9fad3.png";